import { HttpContextToken, HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';
import { ModalService } from '../util/modal.service';
import { AuthService } from './auth.service';



export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(
    private _auth: AuthService,
    private _modal: ModalService,
    private _route: Router,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const skipLoading = req.context.get(SKIP_LOADING);

    let client_id: string
    let auth: string
    let access_token: string
    let user = this._auth.getUser()
    client_id = this._auth.getClientId()
    auth = this._auth.getToken()
    access_token = this._auth.getAccessToken()

    if (req.method === 'GET') {
      req = req.clone({
        setHeaders: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        }
      });
    }
    let authreq = req.clone({
      setHeaders: {
      'Authorization': auth || '',
      'access_token': access_token ? 'Bearer ' + access_token : '',
      'client_id': client_id || '',
      'X-Device-Id': 'BACK_OFFICE_USER_EXPRESS',
      'X-Platform': 'WEB',
      'X-Application': 'BOF',
      'identity_token': this._auth.getHeader()?.identity_token || '',
      'X-User-Id': this._auth.getHeader()?.user_id || '',
      'firebase_token': this._auth.getHeader()?.firebase_token || '',
      'X-Path': req.urlWithParams || '',
      'Data': this._auth.getData() || '',
      'X-Transactional-Id': uuidv4(),
      'username': user?.email || '',
      'X-Store-Id': this._auth.store?.storeId || '',
      }
    });

    if (!skipLoading) {
      this._modal.showLoading();
    }

    return next.handle(authreq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401) {
          this._auth.logout()
          this._route.navigate(['public/sign/login'])
          this._modal.showModalError('Sesión terminada', 'Su sesión ha terminado, por favor vuelva a iniciar sesión')
          return throwError(error);
        } else {
          return throwError(error);
        }
      }),
      finalize(() => {
        if (!skipLoading) {
          this._modal.hideLoading();
        }
      })
    );

  }

}
